/**
 * Created by PhpStorm.
 * Copyright: David Obdržálek, Carpe Noctem, s.r.o.
 * Date: 2019-01-22 16:19
 */

include('inc/carpe.basic.js');
include('inc/carpe.fx.js');
// include('inc/carpe.socgal.js');

$(() => {
  $('a[href^="/programy/"], [data-href^="/programy/"]').off('click').on('click', function(e) {
    if (!$('#scroll-detail').length) return;
    let uri = ($(this).attr('href') || $(this).data('href') || '').split(/[\/#]/)[2];
    if (!uri) return;
    e.stop();

    $('#scroll-detail').removeClass('hide').addClass('loading').scrollTo();
    $.ajax(`/programy/${uri}?ajax`).always(resp => {
        if (resp && resp.status === 200 && resp.responseText) {
          $('#scroll-detail').removeClass('loading');
          $('#scroll-detail .cnt').html(resp.responseText);
          $('.regform form').off('submit').ajaxForm();
        } else {
          console.warn(resp);
          $('#scroll-detail').removeClass('loading');
          $('#scroll-detail .cnt').html('<p class="strong red center">Nelze načíst stránku</p>');
        }
      });
  });
});

Carpe.scrollOffset = -2;
